// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import http from './axios'
import 'element-ui/lib/theme-chalk/index.css';
import animated from 'animate.css';
import './style/index.scss';

import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css';

import scroll from 'vue-seamless-scroll';
Vue.use(scroll);
Vue.use(VueQuillEditor);
Vue.use(ElementUI);
Vue.use(animated);
Vue.config.productionTip = false;
Vue.prototype.$http = http;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js